<template>
  <div class="text-input"
       :class="brandClass">
    <b-form-group :id="`${id}Group`"
                  :label-sr-only="!showLabel"
                  :label="label"
                  :label-for="`${id}Input`">
      <b-form-input :id="`${id}Input`"
                    :aria-describedby="errorIds"
                    :aria-labelledby="`${id}Group`"
                    :class="inputClasses"
                    :disabled="disabled"
                    :state="showError"
                    :style="inputStyles"
                    :type="type"
                    class="focusable"
                    v-model="textInput"
                    v-bind="$attrs"
                    v-on="$listeners">
      </b-form-input>
      <slot></slot>
    </b-form-group>
  </div>
</template>

<script>
import Router from '../../../utility/routerUtil'

export default {
  name: 'text-input',

  props: {
    disabled: {
      type: [Boolean],
      default: false
    },

    errorIds: {
      type: [String],
      default: ''
    },

    hasError: {
      type: [Boolean],
      default: null
    },

    id: {
      type: [String],
      default: 'defaultId'
    },

    inputClasses: {
      type: [String],
      default: ''
    },

    inputStyles: {
      type: [Object],
      default: () => ({})
    },

    label: {
      type: [String],
      default: ''
    },

    showLabel: {
      type: [Boolean],
      default: true
    },

    type: {
      type: [String],
      default: 'text'
    },

    value: {
      type: [String],
      default: ''
    }
  },

  data () {
    return {
      brandClass: Router.getCurrentRouteBrandClass(this.$route)
    }
  },

  computed: {
    showError () {
      return this.hasError === true ? false : null
    },

    textInput: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../../assets/styles/colors';

::v-deep label {
  margin-bottom: 0.125rem;
  font-size: 14px;
}

::v-deep .form-group {
  margin-bottom: 0;
}

::v-deep .form-control {
  border: 1px solid colors.$gray-300;

  &.is-invalid {
    padding: 0.375rem 0.75rem;
    border: 1px solid colors.$red-1;
  }

  &:disabled {
    background: colors.$gray-200;
    border: colors.$gray-300 solid 1px;
  }

  &:focus {
    box-shadow: none;
  }
}
</style>
